import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { DeviceRoutes } from '../device/device-routes';
import IoTSeedOverview from './iot-seed-overview/iot-seed-overview.component';

const IoTOverview = lazy(() => import('./iot-overview/iot-overview'));
const IoTCreate = lazy(() => import('./iot-create/iot-create.component'));
const IoTDetail = lazy(() => import('./iot-detail/iot-detail.component'));
const IoTUpdate = lazy(() => import('./iot-update/iot-update.component'));
const IotTimerCreate = lazy(() => import('../iot-timer/iot-timer-create/iot-timer-create.component'));
const IotTimerUpdate = lazy(() => import('../iot-timer/iot-timer-update/iot-timer-update.component'));

const DeviceRoute = DeviceRoutes();

export function IOTRoutes() {
    return (
        <Route path='iots'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <IoTOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <IoTCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':iotId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <IoTDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <IoTUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='seeds'
                    element={
                        <Navigate
                            to='../detail?menu=seeding'
                            replace
                        />
                    }
                />

                <Route
                    path='seeds/:api'
                    element={
                        <AsyncComponent>
                            <IoTSeedOverview />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='timers/create'
                    element={
                        <AsyncComponent>
                            <IotTimerCreate />
                        </AsyncComponent>
                    }
                />
                <Route path='timers'>
                    <Route
                        path=':timerId/update'
                        element={
                            <AsyncComponent>
                                <IotTimerUpdate />
                            </AsyncComponent>
                        }
                    />
                </Route>
                {DeviceRoute}
            </Route>
        </Route>
    );
}

export default IOTRoutes;
